import React, { useState  } from "react";
import Logo from "../../common/mobile/Logo";
import { Link } from "react-router-dom";

const Footer = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net)$/i, '');
   

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };
    return (
        <div  className="ng-tns-c855548785-1 ng-trigger ng-trigger-footerFadeInAni ng-star-inserted" style={{}}>
       
          <footer  className="footer ng-star-inserted">
           
              <div  className={`footer-seo-content-wrapper ng-star-inserted ${isExpanded ? '' : 'folded'}`} style={{
              height: isExpanded ? "auto" : "200px", 
              
            }}>
                <div >
                  <div  className="ng-star-inserted">
                    <div  className="title">{origin} বাংলাদেশ সরকার কর্তৃক অনুমোদিত — অনলাইন গেমিং ও স্পোর্টস বেটিংয়ের সেরা গন্তব্য</div>
                    <div  className="seo-content">
                      <p>
                        {origin}-এ স্বাগতম! {origin} বাংলাদেশের অন্যতম জনপ্রিয়, নির্ভরযোগ্য ও নিরাপদ অনলাইন গেমিং এবং স্পোর্টস বেটিং প্ল্যাটফর্ম। এখানে একই জায়গায় পাবেন ক্যাসিনো গেম, স্লট, ক্র্যাশ গেম, লাইভ ক্যাসিনো, স্পোর্টস বেটিং এবং আধুনিক বেটিং এক্সচেঞ্জ — সবকিছু এক ছাদের নিচে। আমাদের লক্ষ্য হলো বাংলাদেশের প্রতিটি খেলোয়াড়ের জন্য সেরা ও আনন্দময় গেমিং অভিজ্ঞতা তৈরি করা।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <strong>বিশ্বমানের গেমিং অপশন</strong><br />
                        {origin}-এ আপনি পাচ্ছেন I-Sports, JDB, CQ9, Pocket Games, Evolution সহ বিশ্বের নামকরা গেম প্রোভাইডারদের বিশাল কালেকশন। হাই-অকটেন স্লট, ক্লাসিক টেবিল গেম কিংবা ইমার্সিভ লাইভ ডিলার গেম — প্রত্যেক ধরনের খেলোয়াড়ের জন্য রয়েছে কিছু না কিছু।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        লাইভ ক্যাসিনোর রোমাঞ্চ পেতে Sexy এবং Evolution নিয়ে এসেছে বাস্তব ক্যাসিনোর অভিজ্ঞতা সরাসরি আপনার স্ক্রিনে — পেশাদার ডিলার এবং রিয়েল-টাইম গেমপ্লে সহ। আর পোকারের কৌশলগত চ্যালেঞ্জ ভালোবাসলে BPOKER-এ পাবেন দেশ-বিদেশের খেলোয়াড়দের সঙ্গে খেলার অসংখ্য টেবিল ও টুর্নামেন্ট।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <strong>আধুনিক বেটিং এক্সচেঞ্জ</strong><br />
                        {origin} শুধু ক্যাসিনো নয় — সরাসরি অন্য খেলোয়াড়ের বিপক্ষে বাজি ধরার উত্তেজনাপূর্ণ বেটিং এক্সচেঞ্জও রয়েছে। এতে আপনার বাজির ওপর বেশি নিয়ন্ত্রণ থাকে এবং প্রচলিত প্ল্যাটফর্মের তুলনায় প্রায়ই ভালো অডস পাওয়া যায়। ক্রিকেট, ফুটবল কিংবা ঘোড়দৌড় — যেকোনো ইভেন্টে এক্সচেঞ্জে স্মার্ট ও তথ্যভিত্তিক বাজি ধরুন।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        আমাদের স্পোর্টস বেটিং পরিচালিত হয় JB Sports, Horsebook এবং E1SPORT-এর মতো শীর্ষ প্রোভাইডারদের মাধ্যমে, যাতে সবসময় সর্বশেষ অডস ও বিস্তৃত বেটিং মার্কেট পান। প্রি-ম্যাচ থেকে লাইভ ইন-প্লে বেটিং — আমরা কভার করি সব প্রধান খেলা ও ইভেন্ট।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <strong>বৈচিত্র্যময় গেম কালেকশন</strong><br />
                        {origin} বাংলাদেশে রয়েছে প্রতিটি খেলোয়াড়ের পছন্দের গেম। Joker, KA, RT, SG, JILI-সহ শীর্ষ প্রোভাইডারদের সহযোগিতায় স্লট গেমের বিশাল সম্ভার — বিশাল জ্যাকপটের হাই-ভোলাটিলিটি গেম থেকে শুরু করে ক্যাজুয়াল লো-রিস্ক গেম পর্যন্ত। প্রতিটি গেমে রয়েছে আধুনিক গ্রাফিক্স, ইনোভেটিভ ফিচার ও আকর্ষণীয় থিম।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        নতুন কিছু খুঁজছেন? SPRIBE, Yellow Bat, HotRoad ও FASTSPIN-এর মতো প্রোভাইডারদের নিশ গেমগুলোতে পাবেন অনন্য গেমপ্লে মেকানিক্স ও তাজা কনটেন্ট, যা সাধারণ ক্যাসিনো গেম থেকে আলাদা।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <strong>বোনাস ও প্রমোশনে সর্বোচ্চ জেতার সুযোগ</strong><br />
                        {origin}-এ আমরা খেলোয়াড়দের রিওয়ার্ড করতে বিশ্বাস করি। নতুন খেলোয়াড়দের জন্য জেনারাস ওয়েলকাম বোনাস, আর নিয়মিত খেলোয়াড়দের জন্য ডিপোজিট ম্যাচ, ফ্রি স্পিন এবং ক্যাশব্যাকসহ চলমান প্রমোশন — যা আপনার জেতার সম্ভাবনা আরও বাড়িয়ে দেয়।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        রেফারেল প্রোগ্রামেও বাড়তি রিওয়ার্ড! বন্ধুদের {origin}-এ যোগ দিতে আমন্ত্রণ জানান; প্রতিটি বন্ধু সাইন আপ ও ডিপোজিট করলে পাবেন বোনাস ক্রেডিট, যা ব্যবহার করতে পারবেন আমাদের বিশাল গেম লাইব্রেরিতে। এতে আপনার জেতার সম্ভাবনাও বাড়ে, সাথে বন্ধুদের সঙ্গে আনন্দ ভাগাভাগি হয়।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <strong>নিরাপদে ও আত্মবিশ্বাসের সাথে খেলুন</strong><br />
                        {origin}-এ আপনার নিরাপত্তাই আমাদের প্রথম অগ্রাধিকার। PT, WorldMatch, NETENT ও PNG-র মতো স্বনামধন্য প্রোভাইডারদের সঙ্গে কাজ করে আমরা নিশ্চিত করি সব গেম ন্যায্য এবং আপনার ব্যক্তিগত তথ্য সুরক্ষিত। অত্যাধুনিক এনক্রিপশন প্রযুক্তিতে আপনার ডেটা থাকে নিরাপদ — তাই নিশ্চিন্তে খেলুন।
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <strong>{origin} বাংলাদেশ কমিউনিটিতে যোগ দিন</strong><br />
                        সেরা অনলাইন গেমিং ও বেটিং অভিজ্ঞতার জন্য আজই {origin} বাংলাদেশ কমিউনিটিতে যোগ দিন। ব্যবহারকারী-বান্ধব প্ল্যাটফর্মে সহজেই গেম লাইব্রেরি ঘুরে দেখুন, পছন্দের স্পোর্টসে বাজি ধরুন এবং আকর্ষণীয় প্রমোশন উপভোগ করুন। রেফারেল প্রোগ্রামে বন্ধুদের আমন্ত্রণ জানিয়ে বাড়তি রিওয়ার্ড অর্জন করুন। দায়িত্বশীলভাবে খেলুন, আনন্দ নিন — {origin}-এর সাথেই শুরু হোক আপনার গেমিং যাত্রা!
                      </p>
                      <p>&nbsp;</p>
                      <p>
                        <small>১৮+ শুধুমাত্র। দায়িত্বশীলভাবে খেলুন। জুয়া ও বাজি আসক্তি স্বাস্থ্যের জন্য ক্ষতিকর হতে পারে।</small>
                      </p>
                    </div>
                  </div>
                  
                </div>
                <button  onClick={toggleExpand} className="fold-btn button btn-secondary ng-star-inserted">{isExpanded ? "Show Less" : "Show More"}</button>
                
              </div>
            <div  className="footer-top">
              <div  className="list list--sponsor-data">
                <div  className="list__title">Sponsorships</div>
                <div  className="list__wrap">
                  <div  className="list__item item">
                    <div  className="item__icon">
                      <img  mcdsrc="/assets/images/sponsor/delhi-bulls.png" alt="icon-sponsor" src="https://img.j189eb.com/jb/h5/assets/images/sponsor/delhi-bulls.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      <div  className="item__content">
                        <div  className="txt">Delhi Bulls</div>
                        <div  className="sub-txt">
                          <span >Title Sponsor</span><span > 2023 - 2024 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div  className="list list--ambassador-data">
                <div  className="list__title">Brand Ambassadors</div>
                <div  className="list__wrap">
                  <div  className="list__item item">
                    <img  mcdsrc="/assets/images/footer/ambassador_signature/andre-russell.png" className="list__item--img" alt="andre-russell" src="https://img.j189eb.com/jb/h5/assets/images/footer/ambassador_signature/andre-russell.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                    <div  className="item__content">
                      <div  className="txt">Andre Dwayne Russell</div>
                      <div  className="sub-txt"><span > 2024 - 2026 </span></div>
                    </div>
                  </div>
                  <div  className="list__item item">
                    <img  mcdsrc="/assets/images/footer/ambassador_signature/mcgrath.png" className="list__item--img" alt="mcgrath" src="https://img.j189eb.com/jb/h5/assets/images/footer/ambassador_signature/mcgrath.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                    <div  className="item__content">
                      <div  className="txt">Glenn McGrat</div>
                      <div  className="sub-txt"><span > 2023 - 2024 </span></div>
                    </div>
                  </div>
                </div>
              </div>
             
                <div  className="pay ng-star-inserted">
                  <h2 >Payment Methods</h2>
                  <ul >
                    <li  className="ng-star-inserted">
                      <img  alt="pay16" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay16.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay22" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay22.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay33" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay33.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay34" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay34.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay45" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay45.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay59" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay59.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay60" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay60.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay61" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay61.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay47" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay47.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay91" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay91.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                  </ul>
                </div>
                
            
                <div  className="safe ng-star-inserted">
                  <h2 >Responsible Gaming</h2>
                  <ul >
                    <li  className="ng-star-inserted">
                      <Link  target="_blank" href="#" className="ng-star-inserted">
                        <img  alt="Gamcare" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/safe/gamcare.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      </Link>
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <Link  target="_blank" href="#" className="ng-star-inserted">
                        <img  alt="18 Policy" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/safe/age-limit.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      </Link>
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <Link  target="_blank" href="#" className="ng-star-inserted">
                        <img  alt="Responsible Gaming" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/safe/regulations.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      </Link>
                      
                    </li>
                    
                  </ul>
                </div>
            </div>
            <div  className="footer-middle">
              <div  className="gaming-license">
                <h2 >
                  <p >Gaming License</p>
                </h2>
                <ul >
                  <li >
                    <img  mcdsrc="/assets/images/footer/gaming_license.png" alt="gaming_license" src="https://img.j189eb.com/jb/h5/assets/images/footer/gaming_license.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                  </li>
                </ul>
              </div>
              <div className="ng-star-inserted">
                <h2>APP Download</h2>
                <a   href={`./app/${origin}.apk`}>
                  <img
                   
                    mcdsrc="/assets/images/footer/android-en.png"
                    alt="APP Download"
                    src="https://img.j189eb.com/jb/h5/assets/images/footer/android-en.png?v=1737451131402&source=mcdsrc"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
            <div  className="footer-bottom">
              <Logo/>
              <div  className="text">
                <div  className="title">Catch the winning </div>
                <p >© 2017-2025 {origin} Copyrights. All Rights Reserved</p>
              </div>
            </div>
          </footer>
      </div>
      
    );
};

export default Footer;
